import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGiftsState, useListingStore } from '../../store';
import { AddGiftsCtasWithDrawer } from './Gifts/AddGiftsCtasWithDrawer';
import { Flex } from '@opari/ui/Flex';
import { Text } from '@opari/ui/Text';
import { useTranslation } from '../../i18n';
export const ProductGiftSelector = (props) => {
    var _a, _b, _c;
    const t = useTranslation();
    const { setGiftData, giftCard, giftWrap, note } = useListingStore((s) => {
        var _a, _b;
        return ({
            giftCard: (_a = s.giftItems) === null || _a === void 0 ? void 0 : _a.giftCard,
            giftWrap: (_b = s.giftItems) === null || _b === void 0 ? void 0 : _b.giftWrapping,
            note: s.note,
            setGiftData: s.setGiftData,
            product: s.product,
        });
    });
    const { activeDrawer } = useGiftsState();
    const { product, drawerId } = props;
    const hasAccessories = (_a = product === null || product === void 0 ? void 0 : product.accessoryProducts) === null || _a === void 0 ? void 0 : _a.length;
    return (_jsxs(Flex, { flexDirection: "column", children: [_jsx(Text, { children: t('productPage.gifts.addGifts') }), _jsx(AddGiftsCtasWithDrawer, { drawerId: drawerId, open: activeDrawer === drawerId, showGiftCard: (_b = product === null || product === void 0 ? void 0 : product.flags) === null || _b === void 0 ? void 0 : _b.giftCards, showGiftWrapping: (_c = product === null || product === void 0 ? void 0 : product.flags) === null || _c === void 0 ? void 0 : _c.giftWrappings, showAccessories: !!hasAccessories, selectedGiftCard: giftCard, selectedGiftWrapping: giftWrap, onChange: (productType, product) => {
                    setGiftData({
                        [productType]: product,
                    });
                }, onDelete: (productType) => {
                    setGiftData({
                        [productType]: undefined,
                    }, note);
                } })] }));
};
//# sourceMappingURL=ProductGiftSelector.js.map